import '@qdesignsystems/design-system-core/styles.css';
import '@qdesignsystems/theme-vestium/styles.css';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { PublicDropPage } from './App.tsx';
import { AppErrorBoundary, installGlobalErrorReporting } from './AppErrorBoundary';
import { LegalPage } from './Legal';
import { captureCampaignParams } from './attribution';

installGlobalErrorReporting();
// Annonslänkar (?ref=…&utm_…) — innan appen läser ?tab=… och städar adressen.
captureCampaignParams();

// Minimal path-based routing: the app otherwise uses tab state, not a router,
// but the public drop share page needs its own unauthenticated URL so it can
// be posted as a link to Instagram/TikTok etc.
const dropRouteMatch = window.location.pathname.match(/^\/drops\/([^/]+)\/?$/);
const legalRoute = window.location.pathname.replace(/\/$/, '') === '/villkor' ? 'villkor'
  : window.location.pathname.replace(/\/$/, '') === '/integritetspolicy' ? 'integritetspolicy' : null;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      {legalRoute ? <LegalPage doc={legalRoute} /> : dropRouteMatch ? <PublicDropPage id={dropRouteMatch[1]} /> : <App />}
    </AppErrorBoundary>
  </React.StrictMode>
);
